import React, { FC } from 'react';
import classNames from 'classnames';
import { SystemButtonProps } from '../button.types';
import { SystemButtonDefault } from '../systemButtonDefaultProps';
import styles from './custom.module.scss';
import { BaseButton } from '../BaseButton';

export const CustomButton: FC<SystemButtonProps> = ({
  dataName,
  className,
  ...rest
}) => {
  return (
    <BaseButton
      {...rest}
      className={classNames(styles.custom, className)}
      name={dataName}
    />
  );
};

CustomButton.defaultProps = SystemButtonDefault;
